import { render, staticRenderFns } from "./RCard.vue?vue&type=template&id=80055d4e&scoped=true&"
import script from "./RCard.vue?vue&type=script&lang=js&"
export * from "./RCard.vue?vue&type=script&lang=js&"
import style0 from "./RCard.vue?vue&type=style&index=0&id=80055d4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80055d4e",
  null
  
)

export default component.exports